export default "__VITE_ASSET__c9c395ee__"